import { render } from "./App.vue?vue&type=template&id=90c88938"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=90c88938&lang=scss"

import exportComponent from "C:\\projects\\Bleckmann\\lions-adventskalender-frontend-bocholt\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__